'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});
var jsxRuntime = require('react/jsx-runtime');
var classnames = require('classnames');
var React = require('react');
var priceAmount = require('@polycard/price-amount');
function _interopDefaultLegacy(e) {
  return e && typeof e === 'object' && 'default' in e ? e : {
    'default': e
  };
}
var classnames__default = /*#__PURE__*/_interopDefaultLegacy(classnames);
var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}

/**
 * acronym: Not Supported in HTML5.
 * var, tt: Not Supported by JSX.IntrinsicElements then there were remove.
 */
const Inlines = ['a', 'abbr', 'b', 'bdo', 'big', 'br', 'button', 'cite', 'code', 'dfn', 'em', 'i', 'img', 'input', 'kbd', 'label', 'map', 'object', 'output', 'q', 'samp', 'script', 'select', 'small', 'span', 'strong', 'sub', 'sup', 'textarea', 'time', 'p'];
const getInlineComponent = (as, url) => {
  if (url) return 'a';
  if (as && Inlines.includes(as)) return as;
  return 'span';
};
const Text = _ref => {
  let {
    children,
    as,
    styles,
    className,
    url,
    id,
    target,
    ariaHidden,
    ariaLabel,
    isAsText,
    onClick
  } = _ref;
  const Component = isAsText ? getInlineComponent(as, url) : React.Fragment;
  // validamos si el componente es Fragment para no agregar props innecesarios
  const props = Component === React.Fragment ? {} : _extends({}, styles && {
    style: styles
  }, id && {
    id
  }, url && {
    href: url
  }, url && {
    target: target || '_self'
  }, ariaHidden && {
    'aria-hidden': true
  }, ariaLabel && {
    'aria-label': ariaLabel
  }, className && {
    className: classnames__default["default"](className)
  }, onClick && {
    onClick
  });
  return jsxRuntime.jsx(Component, _extends({}, props, {
    children: children
  }));
};
const Blocks = ['article', 'aside', 'blockquote', 'details', 'dialog', 'dd', 'div', 'dl', 'dt', 'fieldset', 'figcaption', 'figure', 'footer', 'form', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'header', 'hgroup', 'hr', 'li', 'main', 'nav', 'ol', 'p', 'pre', 'section', 'table', 'ul'];
const getBlockComponent = as => {
  if (as && Blocks.includes(as)) return as;
  return React__default["default"].Fragment;
};
const Box = _ref => {
  let {
    children,
    as,
    styles,
    className,
    id
  } = _ref;
  const Container = getBlockComponent(as);
  // validamos si el componente es Fragment para no agregar props innecesarios
  const containerProps = Container === React.Fragment ? {} : {
    className: classnames__default["default"](className),
    style: styles,
    id
  };
  return jsxRuntime.jsx(Container, _extends({}, containerProps, {
    children: children
  }));
};
const ImageBuilder = _ref => {
  let {
    src,
    alt,
    className,
    'aria-hidden': ariaHidden
  } = _ref;
  return jsxRuntime.jsx("img", {
    src: src,
    alt: alt,
    className: className,
    "aria-hidden": ariaHidden,
    width: 24,
    height: 24
  });
};
const IconOptions = ['black_friday', 'bookmark', 'calendar', 'cbt', 'close', 'cockade', 'compats', 'coupon', 'cpg', 'file', 'full_super_mlb', 'full_super', 'full', 'installation_services', 'meli_plus', 'meli', 'melicoin', 'size_chart', 'star_fill', 'star_half', 'star', 'tour', 'trade_in', 'warning'
// agregar aca los IDs de los nuevos iconos
];

// Mapper de iconKey a IconOptions
const iconMapping = {
  bf_v6_coupons: 'coupon',
  black_friday_icon: 'black_friday',
  buflo_congrats_information_cbt: 'cbt',
  buflo_reference_installation: 'installation_services',
  ic_online_visit_request: 'calendar',
  icon_black_friday: 'black_friday',
  icon_bookmark: 'bookmark',
  icon_cbt: 'cbt',
  icon_close: 'close',
  icon_cockade: 'cockade',
  icon_file: 'file',
  icon_full_super_mlb: 'full_super_mlb',
  icon_full_super: 'full_super',
  icon_full: 'full',
  icon_meli_plus: 'meli_plus',
  icon_meli: 'meli',
  icon_melicoin: 'melicoin',
  icon_star_fill: 'star_fill',
  icon_star_half: 'star_half',
  icon_star: 'star',
  icon_tour: 'tour',
  icon_trade_in: 'trade_in',
  icon_warning: 'warning',
  meli_icon: 'meli',
  melichoice_new_icon: 'meli',
  meliplus_icon: 'meli_plus',
  polycard_virtual_tour_icon: 'tour',
  size_chart_icon: 'size_chart',
  'spotlight-compatible-green-icon': 'compats',
  supermarket_logo: 'cpg',
  vip_gallery_tour_icon: 'tour',
  vpp_bookmark_icon: 'bookmark',
  vpp_full_icon: 'full',
  vpp_warning_icon: 'warning'
  // Agrega más mapeos según sea necesario
};
const ICONSVIEWBOX = {
  poly_black_friday: '0 0 12 12',
  poly_bookmark: '0 0 20 20',
  poly_calendar: '0 0 14 14',
  poly_cbt: '0 0 154 16',
  poly_close: '0 0 14 14',
  poly_cockade: '0 0 12 12',
  poly_compats: '0 0 16 16',
  poly_coupon: '0 0 13 11',
  poly_cpg: '0 0 106 10',
  poly_file: '0 0 16 16',
  poly_full_super_mlb: '0 0 91 18',
  poly_full_super: '0 0 91 18',
  poly_full: '0 0 41 13',
  poly_installation_services: '0 0 16 16',
  poly_meli_plus: '0 0 43 16',
  poly_meli: '0 0 18 13',
  poly_melicoin: '0 0 19 19',
  poly_size_chart: '0 0 19 11',
  poly_star_fill: '0 0 15 15',
  poly_star_half: '0 0 15 15',
  poly_star: '0 0 15 15',
  poly_tour: '0 0 21 13',
  poly_trade_in: '0 0 16 16',
  poly_warning: '0 0 16 16'
  // agregar aca viewbox de los nuevos iconos
};
const SvgBuilder = _ref => {
  let {
    ariaHidden,
    ariaLabel,
    className,
    height,
    icon,
    width
  } = _ref;
  // mapper que nos permitira ser mas flexibles para facilitar contratos con nativo
  const mappedIcon = iconMapping[icon] || icon;
  // retorno null si el icono no existe en la lista ( evita que se rompa la vista con los ids poly_undefined o poly_otroName)
  if (!IconOptions.includes(mappedIcon)) {
    console.error(`Icon ${mappedIcon} not found`);
    return null;
  }
  const svgHrefID = `poly_${mappedIcon}`;
  const iconViewBox = ICONSVIEWBOX[svgHrefID];
  const iconClass = classnames__default["default"](className, {
    poly_empty_star: mappedIcon === 'star'
  });
  const [defaultWidth, defaultHeight] = iconViewBox.split(' ').slice(2);
  const viewBoxWidth = width || defaultWidth;
  const viewBoxHeight = height || defaultHeight;
  const renderGradient = () => {
    if (mappedIcon === 'meli_plus') {
      return jsxRuntime.jsxs("linearGradient", {
        id: "paint0_linear_8761_4741",
        x1: "0",
        y1: "7.98613",
        x2: "42.0833",
        y2: "7.98613",
        gradientUnits: "userSpaceOnUse",
        children: [jsxRuntime.jsx("stop", {
          offset: "0.298365",
          stopColor: "#5A238D"
        }), jsxRuntime.jsx("stop", {
          offset: "1",
          stopColor: "#AA1192"
        })]
      });
    }
    return null;
  };
  const props = _extends({}, ariaHidden && {
    'aria-hidden': true
  }, ariaLabel && {
    'aria-label': ariaLabel
  }, iconClass && {
    className: iconClass
  });
  return jsxRuntime.jsxs("svg", _extends({}, props, {
    width: viewBoxWidth,
    height: viewBoxHeight,
    viewBox: iconViewBox,
    role: ariaLabel ? 'img' : undefined,
    children: [jsxRuntime.jsx("use", {
      href: `#${svgHrefID}`
    }), renderGradient()]
  }));
};
const IconPhrase = props => {
  const {
    className,
    iconKey,
    src,
    alt_text,
    aria_hidden,
    aria_label = alt_text
  } = props;
  return src ? jsxRuntime.jsx(ImageBuilder, {
    src: src,
    alt: aria_label,
    className: className,
    "aria-hidden": aria_hidden
  }) : iconKey && jsxRuntime.jsx(SvgBuilder, {
    icon: iconKey,
    className: className,
    ariaLabel: aria_label,
    ariaHidden: aria_hidden
  });
};

// temporal mapper for Andes Names
const styleAndesMapping = {
  caution: '#f73',
  positive: '#00a650',
  primary: '#000000e6',
  secondary: '#0000008c'
};
const styleMapping = {
  color: {
    getStyleValue: value => ({
      color: styleAndesMapping[value] || value
    }),
    // Retorna un objeto con la propiedad
    canUseInContainer: false // valida si sera usado en Box
  },
  color_hex: {
    getStyleValue: value => ({
      color: value
    }),
    canUseInContainer: false
  },
  background_color: {
    getStyleValue: value => ({
      backgroundColor: styleAndesMapping[value] || value
    }),
    canUseInContainer: true
  },
  background_color_hex: {
    getStyleValue: value => ({
      backgroundColor: value
    }),
    canUseInContainer: true
  },
  justify_content: {
    getClassName: value => `poly-jc-${value}`,
    // Retorna el nombre de la clase
    canUseInContainer: true
  },
  font_size: {
    getClassName: value => `poly-fs-${value}`,
    canUseInContainer: false
  },
  font_weight: {
    getClassName: value => `poly-fw-${value}`,
    canUseInContainer: false
  },
  line_height: {
    getClassName: value => `poly-lh-${value}`,
    canUseInContainer: true
  },
  text_transform: {
    getClassName: value => `poly-tt-${value}`,
    canUseInContainer: false
  }
  // aca se agregan los nuevos estylos , con los valores que se deben usar en estilos inline o clases con formato CssPropertis
};

// Procesar styles y retornar un string con las clases correspondientes, para Box y para Text segun corresponda
const processClasses = function (styles, canUseInContainerCheck, baseClassName) {
  if (baseClassName === void 0) {
    baseClassName = '';
  }
  return Object.entries(styles).reduce((acc, _ref) => {
    let [key, value] = _ref;
    const mapping = styleMapping[key];
    if ((canUseInContainerCheck === undefined || (mapping == null ? void 0 : mapping.canUseInContainer) === canUseInContainerCheck) && mapping != null && mapping.getClassName) {
      acc.push(mapping.getClassName(value));
    }
    return acc;
  }, baseClassName ? [baseClassName] : []);
};

// Procesar styles y retornar un objeto con las propiedades CSS, para Box y para Text segun corresponda
const processStyles = (styles, canUseInContainerCheck) => Object.entries(styles).reduce((acc, _ref) => {
  let [key, value] = _ref;
  const mapping = styleMapping[key];
  if (mapping != null && mapping.getStyleValue && (canUseInContainerCheck !== undefined ? mapping.canUseInContainer === canUseInContainerCheck : true)) {
    Object.assign(acc, mapping.getStyleValue(value));
  }
  return acc;
}, {});
const getStylesAndClasses = (className, styles, asBox, boxClassName) => {
  const isBox = asBox !== undefined;
  const tmpBoxClassName = boxClassName || className;
  const tmpTextClassName = boxClassName ? className : undefined;
  if (!styles) {
    return {
      boxStyles: {},
      boxClasses: isBox ? [tmpBoxClassName] : [],
      textStyles: {},
      textClasses: isBox ? [tmpTextClassName] : [className]
    };
  }
  // Estilos en linea para Box
  const boxStyles = isBox ? processStyles(styles, true) : {};
  // Classes para Box
  const boxClasses = isBox ? processClasses(styles, true, tmpBoxClassName) : [];
  // Estilos en linea para Text
  const textStyles = isBox ? processStyles(styles, false) : processStyles(styles);
  // Classes para Text
  const textClasses = isBox ? processClasses(styles, false, tmpTextClassName) : processClasses(styles, undefined, className); // Todas las clases si isBox es false
  return {
    boxStyles,
    boxClasses,
    textStyles,
    textClasses
  };
};
const LabelPhrase = _ref => {
  let {
    text,
    styles,
    className,
    aria_hidden,
    aria_label
  } = _ref;
  const baseClassName = `poly-phrase-label`;
  // Estilos en linea generales
  const labelStyles = styles ? processStyles(styles) : {};
  // Classes para generales
  const labelClasses = styles ? processClasses(styles, undefined, baseClassName) : [baseClassName]; // Todas los estilos podibles con clases
  return jsxRuntime.jsx("span", {
    style: labelStyles,
    className: classnames__default["default"](className, labelClasses),
    "aria-label": aria_label,
    "aria-hidden": aria_hidden,
    children: text
  });
};
function _objectWithoutPropertiesLoose(r, e) {
  if (null == r) return {};
  var t = {};
  for (var n in r) if ({}.hasOwnProperty.call(r, n)) {
    if (e.includes(n)) continue;
    t[n] = r[n];
  }
  return t;
}
const _excluded = ["className", "styles", "size", "value"];
const PricePhrase = _ref => {
  let {
      className,
      styles,
      size = 'inherit',
      value = 0
    } = _ref,
    props = _objectWithoutPropertiesLoose(_ref, _excluded);
  const baseClassName = `poly-phrase-price`;
  // Estilos en linea generales
  const priceStyles = styles ? processStyles(styles) : {};
  // Classes para generales
  const priceClasses = styles ? processClasses(styles, undefined, baseClassName) : [baseClassName]; // Todas los estilos podibles con clases
  const Wrapper = Object.keys(priceStyles).length > 0 ? 'span' : React.Fragment; // wrapper solo si hay estilos en linea que aplicar, ya que money-amount no acepta estilos en linea
  const WrapperProps = Wrapper === React.Fragment ? {} : {
    style: priceStyles
  };
  return jsxRuntime.jsx(Wrapper, _extends({}, WrapperProps, {
    children: jsxRuntime.jsx(priceAmount.PriceAmount, _extends({}, props, {
      size: size,
      value: value,
      className: classnames__default["default"](className, priceClasses)
    }))
  }));
};
const getInterpolationsList = text => {
  const regex = /{(.*?)}/g;
  let lastIndex = 0;
  const matches = text.match(regex) || [];
  // recorro todos los elementos que esten dentro de las llaves {}
  const parts = matches.reduce((acc, match) => {
    const key = match.slice(1, -1); // Remove the curly braces
    const index = text.indexOf(match, lastIndex);
    // agrego el texto antes de la interpolacion
    if (index > lastIndex) {
      acc.push({
        text: text.slice(lastIndex, index),
        isInterpolation: false
      });
    }
    // agrego la interpolacion
    acc.push({
      text: key,
      isInterpolation: true
    });
    lastIndex = index + match.length; // actualizo el ultimo indice
    return acc;
  }, []);
  // agrego el texto despues de la ultima interpolacion
  if (lastIndex < text.length) {
    parts.push({
      text: text.slice(lastIndex),
      isInterpolation: false
    });
  }
  return parts;
};

// TODO: Borrar estos Default cuando se arregle el caso
const needDefaultValues = ['icon_meli', 'icon_full_super_mlb', 'icon_full_super'];
const defaultValues = {
  icon_meli: {
    type: 'icon',
    key: 'icon_meli',
    icon: {
      key: 'icon_meli'
    }
  }
};
const Interpolator = _ref => {
  let {
    text,
    values,
    iconClassName,
    thousandSeparator,
    decimalSeparator
  } = _ref;
  const renderText = () => {
    const parts = getInterpolationsList(text);
    // copia los valores para no modificar el array original
    let valuesCopy = [...(values || [])];
    return parts.map((part, index) => {
      var _value$icon;
      // Si no es una interpolacion, retorna el texto
      if (!part.isInterpolation) {
        return part.text;
      }
      // Si es una interpolacion y necesita valores por defecto, los agrega conservando los valores que ya tenia
      if (part.isInterpolation && needDefaultValues.includes(part.text)) {
        valuesCopy = valuesCopy.filter(v => v.key !== part.text); // Elimina el valor si ya existe
        valuesCopy = [...valuesCopy, defaultValues[part.text]];
      }
      // Si es una interpolacion y tiene valores, los interpola
      if (part.isInterpolation && valuesCopy) {
        const value = valuesCopy.find(v => v.key === part.text);
        // Si se encuentra un value para la interpolacion, lo renderiza
        if (value && value.type) {
          const uniqueKey = `${value.key}-${index}`;
          switch (value.type) {
            case 'price':
              return jsxRuntime.jsx(PricePhrase, _extends({}, value.price, {
                styles: value.styles,
                thousandSeparator: thousandSeparator,
                decimalSeparator: decimalSeparator
              }), uniqueKey);
            case 'icon':
              return /*#__PURE__*/React.createElement(IconPhrase, _extends({
                className: iconClassName,
                iconKey: (_value$icon = value.icon) == null ? void 0 : _value$icon.key
              }, value.icon, {
                key: uniqueKey
              }));
            case 'label':
              return /*#__PURE__*/React.createElement(LabelPhrase, _extends({}, value.label, {
                styles: value.styles,
                key: uniqueKey
              }));
            default:
              return null;
          }
        }
      }
      return null; // retorna null si no se encuentra un value para la interpolacion
    });
  };
  return jsxRuntime.jsx(jsxRuntime.Fragment, {
    children: renderText()
  });
};
const Phrase = props => {
  const {
    alt_text,
    aria_hidden,
    aria_label,
    asBox,
    asText,
    className = '',
    id,
    isAsText = true,
    onClick,
    styles,
    target,
    text,
    url,
    values,
    iconClassName,
    thousandSeparator = undefined,
    decimalSeparator = undefined,
    boxClassName
  } = props;
  const {
    boxStyles,
    boxClasses,
    textStyles,
    textClasses
  } = getStylesAndClasses(className, styles, asBox, boxClassName);
  return jsxRuntime.jsx(Box, {
    as: asBox,
    styles: boxStyles,
    className: classnames__default["default"](boxClasses),
    id: id,
    children: jsxRuntime.jsx(Text, {
      ariaHidden: aria_hidden,
      ariaLabel: aria_label || alt_text,
      as: asText,
      className: classnames__default["default"](textClasses),
      id: asBox ? undefined : id,
      isAsText: isAsText,
      onClick: onClick,
      styles: textStyles,
      target: target,
      url: url,
      children: text && jsxRuntime.jsx(Interpolator, {
        text: text,
        values: values,
        iconClassName: iconClassName,
        thousandSeparator: thousandSeparator,
        decimalSeparator: decimalSeparator
      })
    })
  });
};
exports.Phrase = Phrase;
exports.SvgBuilder = SvgBuilder;
